(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    const inputs = document.querySelectorAll('input[data-domain]');
  // const curDomain = window.location.hostname;
  const curDomain = window.location.href;

  inputs.forEach(input => {
    input.value = curDomain;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-top-bar"] && !Shopify.designMode) return;
  try {
    initTomSelect();
initSwiper();
bindBrandSelectChange();
bindBrandButtonClicks();

document.addEventListener('facet:updated', () => {
  console.log('facet updates is uitgevoerd');
  initTomSelect();
  initSwiper();
  bindBrandSelectChange();
  bindBrandButtonClicks();
  // andere reinitialisaties
});

function bindBrandButtonClicks() {
  const buttons = document.querySelectorAll('.search__filters_brand-btn');
  const select = document.querySelector('#select-brand');

  if (!select) return;

  const tomSelectInstance = select.tomselect;
  if (!tomSelectInstance) {
    console.warn('Tom Select is niet geïnitialiseerd.');
    return;
  }

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const value = button.dataset.value;
      
      const searchUrl = button.dataset.searchUrl;
      const btnText = button.querySelector('a')?.textContent;

      const searchContainer = document.querySelector('.search__filters_wrap');
      const loadingSpinner = document.querySelector('.big-search__filters-loading-spinner');

      loadingSpinner.classList.remove('hidden');
      searchContainer.classList.add('loading');

       fetch(searchUrl)
      .then(response => response.text())
      .then(html => {
        parseHTML(html, btnText, value);
        loadingSpinner.classList.add('hidden');
        searchContainer.classList.remove('loading');
      })
      .catch(error => {
        console.error('Fout bij ophalen:', error);
      });

      document.body.style.overflow = '';
    });
  });
}



function initTomSelect(selector) {
  new TomSelect("#select-brand", {
    persist: true,
    create: true,
    // sortField: [{ field: '$order' }],
    // searchField: ['text']
    sortField:[{field:'$order'},
    {field:'$score'}]

  });
}

function initSwiper(){
  const swiper = new Swiper('.search__filters_swiper', {
    loop: false,
    slidesPerView: 8,
    spaceBetween: 12,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      320: {
        slidesPerView: 3
      },
      480: {
        slidesPerView: 3
      },
      992: {
        slidesPerView: 8
      }
    }
  });
}

function bindBrandSelectChange() {
  const selectBrand = document.querySelector('#select-brand');
  if (selectBrand) {
    selectBrand.addEventListener('change', function () {
      handleBrandSelectChange(selectBrand.value);
    });
  }
}


function handleBrandSelectChange(selectedValue) {
  const customFilterSearchInput = document.querySelector('.custom-filter-search');
  const form = document.querySelector('.filter-form');

  console.log('selectedValue', selectedValue);

  // Voeg waarde toe aan zoekveld
  if (customFilterSearchInput) {
    const existingValue = customFilterSearchInput.value;
    customFilterSearchInput.value = existingValue ? `${existingValue} ${selectedValue}` : selectedValue;
  }

  // Vink bijbehorende checkbox aan
  document.querySelectorAll('.checkbox-container .checkbox').forEach(function (checkbox) {
    if (checkbox.value === selectedValue) {
      checkbox.checked = true;
    }
  });

  // Trigger formulierlogica
  if (form && typeof form._onFormChanged === 'function') {
    form._onFormChanged();
  }
}

// Voegt de filters die we ophalen vanuit de brands toe aan de filters op de huidige pagina

function parseHTML(html, btnText, value) {
  // Parse HTML en update filters
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const suitableForFilter = doc.querySelector('.checkbox-list.suitable-for');
  const select = document.querySelector('#select-brand');

  if (!suitableForFilter) {
    console.error("Geen 'Suitable for' filter gevonden!");    
    return;
  }


  const tomSelectInstance = select.tomselect;

  // Update checkboxes en select options
  const checkboxes = suitableForFilter.querySelectorAll('.checkbox-container .checkbox');
  const filterForm = document.querySelector('.filter-form');
  const checkboxList = filterForm.querySelector('.checkbox-list.suitable-for');

  checkboxes.forEach(checkbox => {
    addCheckboxToForm(checkbox, checkboxList);
    addOptionToSelect(checkbox, tomSelectInstance);
  });

  setTimeout(function(){
    tomSelectInstance.refreshOptions();
    tomSelectInstance.setTextboxValue(value);
    tomSelectInstance.open();
    // tomSelectInstance.refreshOptions();
    // tomSelectInstance.addItem(value); // selecteert de juiste waarde
    // tomSelectInstance.open();
  }, 200);
}


// Voegt de nieuwe filters toe aan het filter formulier op de huidige pagina
function addCheckboxToForm(checkbox, checkboxList) {
  const container = document.createElement('div');
  container.className = 'checkbox-container';
  
  const clonedCheckbox = checkbox.cloneNode(true);
  clonedCheckbox.id = `checkbox-${Math.random().toString(36).substr(2, 9)}`;
  
  const label = document.createElement('label');
  label.setAttribute('for', clonedCheckbox.id);
  label.textContent = `${checkbox.value} (${checkbox.nextElementSibling.textContent.match(/\((\d+)\)/)?.[1] || '0'})`;

  
  container.append(clonedCheckbox, label);
  checkboxList.appendChild(container);
}

function addOptionToSelect(checkbox, select) {
  const option = document.createElement('option');
  option.value = checkbox.value;
  option.textContent = checkbox.value;
  console.log('option select', option);
  select.addOption({ value: checkbox.value, text: checkbox.value });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["horizontal-product-modal"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    // Upsell products images slider
    const upsellImagesSlider = new Swiper(".product-info__slider", {
      slidesPerView: 2,
      spaceBetween: 8,
      draggable: true,
      navigation: {
        nextEl: '.slider-next-button',
        prevEl: '.slider-prev-button',
      },

      breakpoints: {
        768: {
          slidesPerView: 3,
        }
      }
    })

    // FIX: Move upsell drawers to body to escape cart-drawer stacking context
    function moveUpsellDrawers() {
      // Safety net: een quick-buy-drawer in een modal-knop zou een duplicaat-id zijn
      // (de echte drawer staat 1x op tile-niveau) — hier weghalen, ook na AJAX-herrenders.
      document.querySelectorAll('.product-info__modal-button quick-buy-drawer').forEach(drawer => {
        drawer.remove();
      });

      document.querySelectorAll('x-drawer.x-drawer--upsell').forEach(drawer => {
        const existingDrawer = document.body.querySelector(':scope > x-drawer#' + CSS.escape(drawer.id));
        
        // Remove old duplicate if exists
        if (existingDrawer) {
          existingDrawer.remove();
        }
        
        // Move to body
        document.body.appendChild(drawer);
      });
    }

    // Initial move
    moveUpsellDrawers();

    // Na een add-to-cart de open info-modal sluiten. Dit verving de is: 'close-button' op de
    // submit-knop, die als bijeffect ook de cart drawer zelf sloot (dicht-en-weer-open bij toevoegen).
    document.addEventListener('variant:add', () => {
      document.querySelectorAll('x-drawer.x-drawer--upsell[open]').forEach(drawer => drawer.hide());
    });

    // Re-run after cart updates (handles AJAX cart refreshes)
    document.addEventListener('cart:refresh', moveUpsellDrawers);
    
    // Also observe for section re-renders
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            setTimeout(moveUpsellDrawers, 100);
          }
        });
      });
      observer.observe(cartDrawer, { childList: true, subtree: true });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["horizontal-product"] && !Shopify.designMode) return;
  try {
    const inputs = document.querySelectorAll('input[data-domain]');
  // const curDomain = window.location.hostname;
  const curDomain = window.location.href;

  inputs.forEach(input => {
  
    input.value = curDomain;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["offer"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector('.product-info__offer-list .offer.with-timer');
  if (!wrapper) return;

  const timer = wrapper.querySelector('.timer');
  if (!timer) return;

  const timeFromStr = timer.getAttribute('time-from');
  const timeTillStr = timer.getAttribute('time-till');
  const saturdayCheck = timer.getAttribute('data-saturday-check') === 'true';
  const sundayCheck = timer.getAttribute('data-sunday-check') === 'true';

  if (!timeFromStr || !timeTillStr) return;

  const now = new Date();
  const day = now.getDay(); // 0 = zondag, 6 = zaterdag

  if ((saturdayCheck && day === 6) || (sundayCheck && day === 0)) {
    wrapper.style.display = 'none';
    return;
  }

  const from = parseTime(timeFromStr);
  const till = parseTime(timeTillStr);
  const nowMinutes = now.getHours() * 60 + now.getMinutes();
  const fromMinutes = from.hours * 60 + from.minutes;
  const tillMinutes = till.hours * 60 + till.minutes;

  if (nowMinutes < fromMinutes || nowMinutes > tillMinutes) {
    wrapper.style.display = 'none';
  }

  function parseTime(timeStr) {
    const [h, m] = timeStr.split(':').map(Number);
    return { hours: h, minutes: m };
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // setTimeout(function(){
  const inputs = document.querySelectorAll('input[data-domain]');
  // const curDomain = window.location.hostname;
  const curDomain = window.location.href;

  inputs.forEach(input => {
    input.value = curDomain;
  });
// }, 2000);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-carousel"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    const activeLabels = document.querySelectorAll('[data-option-value]');
    const mediaGaleries = document.querySelectorAll('[data-gallery-value]');

    if (activeLabels.length > 0) {
      activeLabels.forEach((label) => {
        label.addEventListener('click', (e) => {
          const labelValue = label.dataset.optionValue;
          const activeGallery = document.querySelectorAll(`[data-gallery-value="${labelValue}"]`);

          if (mediaGaleries && activeGallery.length > 0) {
            mediaGaleries.forEach((gallery) => {
              if (gallery.dataset.galleryValue == labelValue) {
                gallery.classList.remove('hidden');
              } else {
                gallery.classList.add('hidden');
              }
            });
          }
        });
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["search-product-popup"] && !Shopify.designMode) return;
  try {
    const openSearchPopupActive = document.querySelector('.open__search_popup');

function initPopupHandlers() {
  const overlay = document.querySelector('.popup__overlay');
  const popup = document.querySelector('.search__product__popup');
  const closeBtn = document.querySelector('.popup__close');
  const openSearchPopup = document.querySelector('.open__search_popup');

  // Functie om popup te tonen
  function showPopup() {
    if (overlay && popup) {
      overlay.style.display = 'block';
      popup.style.display = 'block';
      document.body.style.overflow = 'hidden';
      console.log('click click');
    }
  }

  // Functie om popup te verbergen
  function hidePopup() {
    if (overlay && popup) {
      overlay.style.display = 'none';
      popup.style.display = 'none';
      document.body.style.overflow = '';
    }
  }

  // Sluit bij klik op overlay of sluitknop
  if (overlay) overlay.addEventListener('click', hidePopup);
  if (closeBtn) closeBtn.addEventListener('click', hidePopup);
  if (openSearchPopup) openSearchPopup.addEventListener('click', showPopup);

  // Escape key handler (eenmalig)
  if (!document._popupEscapeBound) {
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        hidePopup();
      }
    });
    document._popupEscapeBound = true;
  }
}

// Initieel uitvoeren
initPopupHandlers();

// Optioneel: toon popup automatisch na X seconden
// if(openSearchPopupActive){
//   setTimeout(() => {
//     const overlay = document.querySelector('.popup__overlay');
//     const popup = document.querySelector('.search__product__popup');
//     if (overlay && popup) {
//       overlay.style.display = 'block';
//       popup.style.display = 'block';
//       document.body.style.overflow = 'hidden';
//       console.log('click click');
//     }
//   }, 2000);
// }

// Opnieuw initialiseren na facet update
document.addEventListener('facet:updated', () => {
  initPopupHandlers();
});
  } catch(e) { console.error(e); }
})();

})();
